import React from 'react';
import VideoHero from '../video-hero';
import { Col, Row } from 'react-grid-system';

function CtaSectionRightImage({
    className = "",
    videoPath,
    ctaBgImg,
    ctaBgImgAlt,
    ctaBgMobImg,
    children,
    ctaImg,
    ctaImgAlt,
    secTitle
}) {

    // Determine if the image is decorative
    const isDecorative = ctaImgAlt === 'decorative' || ctaImgAlt === '';

    return (
        <>
            <div className={`cta-section-right-image ${className}`}>

                {videoPath &&
                    <VideoHero className="desktop-only" videoSrc={videoPath} aria-hidden="true" />
                }

                {ctaBgImg &&
                    <div className='cta-bgImg'>
                        <img src={ctaBgImg} alt={ctaBgImgAlt} className="desktop-only" />
                    </div>
                }

                <div className="cta-info-wrapper">
                    {secTitle &&
                        <div className="centered-content">
                            <h2 className='text-head font-22 bold txt-blue'>{secTitle}</h2>
                        </div>
                    }
                    <div className="centered-content border-wrap">
                        <div className="svg-container">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1398 48" fill="none" className="cta-svg">
                                <path d="M2 47.464C2 2 47.4054 2 47.4054 2L1397.5 2" stroke="#90D21F" strokeWidth="4" />
                            </svg>
                        </div>
                        <div className="cta-content">
                            <Row className='row'>
                                <Col lg={6}>
                                    <div className="right-content">
                                        {children}
                                    </div>
                                </Col>
                                <Col lg={6} className='desktop-only'>
                                    <div className="left-content">
                                        <div className="media">
                                            <img src={ctaImg}
                                                alt={isDecorative ? '' : ctaImgAlt}
                                                aria-hidden={isDecorative ? 'true' : 'false'}
                                            />
                                        </div>
                                        <span className='tag-text'>Actor portrayal.</span>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
                <div className="mobile-content mobile-only">
                    {videoPath &&
                        <VideoHero videoSrc={videoPath} />
                    }

                    {ctaBgImg &&
                        <div className='cta-bgImg'>
                            <img src={ctaBgMobImg} alt={ctaBgImgAlt} className="mobile-only" />
                        </div>
                    }
                    <div className="centered-content border-wrap">
                        {/* <div className="svg-container">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1398 48" fill="none" className="cta-svg">
                                <path d="M2 47.464C2 2 47.4054 2 47.4054 2L1397.5 2" stroke="#90D21F" strokeWidth="4" />
                            </svg>
                        </div> */}
                        <div className="left-content">
                            <div className="media">
                                <img src={ctaImg} alt={ctaImgAlt} />
                            </div>
                            <span className='tag-text'>Actor portrayal.</span>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default CtaSectionRightImage;